var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddAnnotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 19.6066L8.1434 16.5H3C2.17157 16.5 1.5 15.8284 1.5 15V4.5C1.5 3.67157 2.17157 3 3 3H19.5C20.3284 3 21 3.67157 21 4.5V15C21 15.8284 20.3284 16.5 19.5 16.5H14.3566L11.25 19.6066ZM7.52208 18L11.25 21.7279L14.9779 18H19.5C21.1569 18 22.5 16.6569 22.5 15V4.5C22.5 2.84315 21.1569 1.5 19.5 1.5H3C1.34315 1.5 0 2.84315 0 4.5V15C0 16.6569 1.34315 18 3 18H7.52208ZM10.5 6.75C10.5 6.33582 10.8358 6 11.25 6C11.6642 6 12 6.33582 12 6.75V9H14.25C14.6642 9 15 9.33582 15 9.75C15 10.1642 14.6642 10.5 14.25 10.5H12V12.75C12 13.1642 11.6642 13.5 11.25 13.5C10.8358 13.5 10.5 13.1642 10.5 12.75V10.5H8.25C7.83577 10.5 7.5 10.1642 7.5 9.75C7.5 9.33582 7.83577 9 8.25 9H10.5V6.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAnnotation);
export default __webpack_public_path__ + "static/media/add-annotation.fbcb9822854bd5159936f6356c1bedf7.svg";
export { ForwardRef as ReactComponent };